import { LoadingOutlined } from "@ant-design/icons";
import { Button, Collapse, Select, Spin } from "antd";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FetchContext from "../../contexts/fetch";

const { Panel } = Collapse;

function VersionList({ flowList }) {
  return (
    <>
      {flowList.map((flow, index) => (
        <div key={index}>
          <Link
            to={`/${flow.app}/${flow.brand}/${flow.name}/${flow.version}`}
            target="_blank"
          >
            {flow.version}
          </Link>
        </div>
      ))}
    </>
  );
}

function AppFlowList({ app, flowList }) {
  const items = flowList
    .map((flow) => flow.name)
    .filter((value, index, self) => self.indexOf(value) === index)
    .sort(function (a, b) {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    })
    .map((flowName) => ({
      key: flowName,
      label: flowName,
      children: (
        <VersionList
          flowList={flowList.filter((flow) => flow.name === flowName)}
        />
      ),
    }));

  return (
    <div style={{ marginTop: "20px" }}>
      <h2>{app}</h2>

      <Collapse accordion>
        {items.map((item) => (
          <Panel header={item.label} key={item.key}>
            {item.children}
          </Panel>
        ))}
      </Collapse>
    </div>
  );
}

export default function Explorer() {
  const [fetchState, fetchDispatcher] = useContext(FetchContext);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedBrandApps, setSelectedBrandApps] = useState([]);

  useEffect(() => {
    fetchDispatcher({
      type: "fetch-flow-list",
      app: null,
    });
  }, [fetchDispatcher]);

  useEffect(() => {
    if (selectedBrand) {
      setSelectedBrandApps(
        fetchState.flows
          .filter((flow) => flow.brand === selectedBrand)
          .map((flow) => flow.app)
          .filter((value, index, self) => self.indexOf(value) === index)
          .sort(function (a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          })
      );
    }
  }, [selectedBrand, fetchState.flows]);

  if (fetchState.loadingFlowListApi) {
    return (
      <div>
        <Spin
          style={{
            margin: "30px auto",
            width: "100%",
          }}
          indicator={
            <LoadingOutlined
              style={{
                fontSize: 24,
              }}
              spin
            />
          }
        />
      </div>
    );
  }

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <div
      style={{
        width: "70%",
        maxWidth: "800px",
        padding: "30px 0px",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          backgroundColor: "black",
          padding: "10px 20px",
          textAlign: "center",
          borderRadius: "10px",
        }}
      >
        <img src="/logo_allobrain.svg" alt="logo" style={{ width: "200px" }} />
      </div>
      <Select
        showSearch
        placeholder="Select a brand"
        optionFilterProp="children"
        value={selectedBrand}
        onChange={(value) => setSelectedBrand(value)}
        filterOption={filterOption}
        options={fetchState.flows
          .map((flow) => flow.brand)
          .filter((value, index, self) => self.indexOf(value) === index)
          .sort(function (a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          })
          .map((brand) => ({
            value: brand,
            label: brand,
          }))}
        style={{ width: "100%", marginTop: "30px" }}
        size="large"
      />

      {selectedBrand && (
        <>
          {selectedBrandApps.map((app) => (
            <AppFlowList
              key={app}
              app={app}
              flowList={fetchState.flows.filter(
                (flow) => flow.brand === selectedBrand && flow.app === app
              )}
            />
          ))}
        </>
      )}

      {!selectedBrand && (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <Link to="/new-flow">
            <Button type="primary" size="large">
              New Flow
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
}
